import React from "react";

import { faTooth } from "@fortawesome/pro-solid-svg-icons";
import { Grid } from "@material-ui/core";

import { CheckBox, Input } from "components/Form/FormikControls";
import { Row } from "components/Layout";
import { Paper } from "components/Paper";
import { MediumText as Heading } from "components/Text";

import { Error, Icon } from "./components";
import { withAttributeNamespace } from "./util";

interface DentitionSectionProps {
  errorMessage?: React.JSX.Element | null;
  zeroLabel?: string;
  namespace?: string;
  readOnly?: boolean;
}

export const DentitionSection = ({
  errorMessage,
  zeroLabel = "Milk",
  namespace,
  readOnly,
}: DentitionSectionProps): React.JSX.Element => (
  <Grid item xs={12}>
    <Paper>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Row flexGrow>
            <Icon icon={faTooth} color="gray44" />
            <Heading>Dentition (hd)</Heading>
            {errorMessage && <Error>{errorMessage}</Error>}
          </Row>
        </Grid>
        <Grid item xs={12}>
          <CheckBox
            name={withAttributeNamespace("isNotMouthed", namespace)}
            label="Not Mouthed"
            disabled={readOnly}
          />
        </Grid>
        <Grid item xs={2}>
          <Input
            label={zeroLabel}
            name={withAttributeNamespace("dentition0", namespace)}
            type="number"
            emptyValue={null}
            disabled={readOnly}
          />
        </Grid>
        <Grid item xs={2}>
          <Input
            label="2T"
            name={withAttributeNamespace("dentition2", namespace)}
            type="number"
            emptyValue={null}
            disabled={readOnly}
          />
        </Grid>
        <Grid item xs={2}>
          <Input
            label="4T"
            name={withAttributeNamespace("dentition4", namespace)}
            type="number"
            emptyValue={null}
            disabled={readOnly}
          />
        </Grid>
        <Grid item xs={2}>
          <Input
            label="6T"
            name={withAttributeNamespace("dentition6", namespace)}
            type="number"
            emptyValue={null}
            disabled={readOnly}
          />
        </Grid>
        <Grid item xs={2}>
          <Input
            label="8T"
            name={withAttributeNamespace("dentition8", namespace)}
            type="number"
            emptyValue={null}
            disabled={readOnly}
          />
        </Grid>
        <Grid item xs={2}>
          <Input
            label="Broken"
            name={withAttributeNamespace("dentitionBroken", namespace)}
            type="number"
            emptyValue={null}
            disabled={readOnly}
          />
        </Grid>
      </Grid>
    </Paper>
  </Grid>
);
